import { render, staticRenderFns } from "./RolePop.vue?vue&type=template&id=c03cb972&scoped=true&"
import script from "./RolePop.vue?vue&type=script&lang=js&"
export * from "./RolePop.vue?vue&type=script&lang=js&"
import style0 from "./RolePop.vue?vue&type=style&index=0&id=c03cb972&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03cb972",
  null
  
)

export default component.exports